<div class="shell-wrapper flex flex-col min-h-screen bg-slate-100">
  <mat-toolbar class="shell-toolbar flex-none" color="white">
    <button
      mat-icon-button
      class="toggle-btn"
      (click)="toggleSidebar()"
      aria-label="Toggle menu"
    >
      <mat-icon class="menu-icon">menu</mat-icon>
    </button>

    <span class="spacer"></span>
    <span class="brand">TBAGROSENSOR</span>
    <span class="spacer"></span>
    <button
      mat-button
      class="user-btn"
      [matMenuTriggerFor]="userMenu"
      title="Usuario"
    >
      <mat-icon class="menu-icon">account_circle</mat-icon>
      <span class="user-email" *ngIf="user">{{ user.email }}</span>
    </button>

    <mat-menu #userMenu="matMenu" xPosition="before">
      <button mat-menu-item disabled class="menu-title">
        {{ 'COMMON.LANGUAGE' | translate }}
      </button>
      <button mat-menu-item class="menu-lang" (click)="setLanguage('es')">
        <span class="lang-flag flag-es" aria-hidden="true"></span>
        <span>{{ 'COMMON.LANGUAGES.ES' | translate }}</span>
        <mat-icon class="menu-check" [class.invisible]="currentLang !== 'es'"
          >check</mat-icon
        >
      </button>
      <button mat-menu-item class="menu-lang" (click)="setLanguage('en')">
        <span class="lang-flag flag-gb" aria-hidden="true"></span>
        <span>{{ 'COMMON.LANGUAGES.EN' | translate }}</span>
        <mat-icon class="menu-check" [class.invisible]="currentLang !== 'en'"
          >check</mat-icon
        >
      </button>
      <button mat-menu-item class="menu-lang" (click)="setLanguage('fr')">
        <span class="lang-flag flag-fr" aria-hidden="true"></span>
        <span>{{ 'COMMON.LANGUAGES.FR' | translate }}</span>
        <mat-icon class="menu-check" [class.invisible]="currentLang !== 'fr'"
          >check</mat-icon
        >
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item class="menu-toggle" (click)="toggleTheme()">
        <mat-icon>{{ isDarkTheme ? 'dark_mode' : 'light_mode' }}</mat-icon>
        <span class="toggle-pill">{{ isDarkTheme ? 'On' : 'Off' }}</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'COMMON.LOGOUT' | translate }}</span>
      </button>
    </mat-menu>
  </mat-toolbar>

  <div class="shell-main flex flex-1 min-h-0 overflow-hidden">
    <nav class="side-nav" [class.collapsed]="collapsed">
      <ul class="menu">
        <li
          *ngFor="let item of menu"
          [class.has-children]="item.children?.length"
          [class.hide-mobile]="item.id === 'config'"
        >
          <a
            *ngIf="!item.children?.length"
            class="menu-link"
            [routerLink]="item.routerLink"
            routerLinkActive="active"
            (click)="onMenuNavigate()"
          >
            <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
            <span class="nav-text">{{
              item.titleKey ? (item.titleKey | translate) : item.title
            }}</span>
          </a>

          <div class="menu-group" *ngIf="item.children?.length">
            <button type="button" class="menu-link" (click)="toggleGroup(item)">
              <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
              <span class="nav-text">{{
                item.titleKey ? (item.titleKey | translate) : item.title
              }}</span>
              <mat-icon class="caret" [class.open]="item.expanded"
                >expand_more</mat-icon
              >
            </button>
            <ul class="submenu" *ngIf="item.expanded">
              <li *ngFor="let sub of item.children" routerLinkActive="active">
                <span class="bullet"></span>
                <a [routerLink]="sub.routerLink" (click)="onMenuNavigate()">{{
                  sub.titleKey ? (sub.titleKey | translate) : sub.title
                }}</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>

    <div
      class="shell-content flex flex-col flex-1 min-h-0 overflow-hidden px-4 pb-4 pt-0"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
